import { __assign, __extends } from "tslib";
import React from 'react';
import LoveButton from './loveButton.js';
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import { utils } from '../utils';
import classNames from 'classnames';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import Share from 'wix-ui-icons-common/on-stage/Share';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
var FullscreenMobileBar = /** @class */ (function (_super) {
    __extends(FullscreenMobileBar, _super);
    function FullscreenMobileBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showShare: false,
        };
        _this.sampleInput = {
            love: {
                onClick: function () { },
                text: '1',
            },
        };
        _this.onShareContainerClick = _this.onShareContainerClick.bind(_this);
        return _this;
    }
    FullscreenMobileBar.prototype.getLoveButton = function () {
        var _a = this.props, styles = _a.styles, love = _a.love, customComponents = _a.customComponents;
        var props = _.pick(this.props, [
            'itemId',
            'id',
            'item',
            'idx',
            'styles',
            'love',
            'hashtag',
            'actions',
        ]);
        return styles.loveButton ? (React.createElement(LoveButton, __assign({}, props, { type: this.props.current.item.type, layout: "fullscreen", device: "mobile", showCounter: true, actions: {
                eventsListener: this.props.actions.eventsListener,
            }, customLoveCounterRenderer: customComponents === null || customComponents === void 0 ? void 0 : customComponents.customLoveCounterRenderer }, this.props.current.itemLoveData))) : ('');
    };
    FullscreenMobileBar.prototype.getDownloadButton = function () {
        var _a = this.props, current = _a.current, styles = _a.styles, additionalNavbarElement = _a.additionalNavbarElement, customDownloadUrl = _a.customDownloadUrl;
        var hasAdditionalNavbarElement = typeof additionalNavbarElement === 'function';
        return (React.createElement(FullscreenSocialDownload, { layout: "fullscreen", device: "mobile", hasAdditionalNavbarElement: hasAdditionalNavbarElement, current: current, styles: styles, customDownloadUrl: customDownloadUrl, actions: {
                eventsListener: this.props.actions.eventsListener,
            } }));
    };
    FullscreenMobileBar.prototype.getAdditionalNavbarElement = function () {
        var additionalNavbarElement = this.props.additionalNavbarElement;
        try {
            if (additionalNavbarElement) {
                return additionalNavbarElement(__assign(__assign({}, this.props), { styleParams: this.props.styles }));
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.error('Could not get additional navbar element', e);
        }
    };
    FullscreenMobileBar.prototype.getShareContainer = function () {
        var shareButton = this.props.styles.allowSocial ? (React.createElement("button", { className: "pro-fullscreen-share-icon", onClick: this.onShareContainerClick },
            React.createElement(Share, null))) : (
        // <i className='progallery-svg-font-icons-share-store pro-fullscreen-share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>
        false);
        return (React.createElement("div", { className: "fullscreen-social" },
            this.getDownloadButton(),
            this.getAdditionalNavbarElement(),
            this.getLoveButton(),
            shareButton));
    };
    FullscreenMobileBar.prototype.onShareContainerClick = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (this.props.shouldUseNewSocialSharePopup) {
            this.props.actions.eventsListener(FULLSCREEN_EVENTS.SOCIAL_SHARE_BUTTON_CLICKED, __assign(__assign({ showSocialSharePopup: true }, this.props), { title: ((_e = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.dto) === null || _d === void 0 ? void 0 : _d.metaData) === null || _e === void 0 ? void 0 : _e.title) || '', directShareLink: ((_j = (_h = (_g = (_f = this.props) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.dto) === null || _j === void 0 ? void 0 : _j.directShareLink) || '', createUrl: ((_m = (_l = (_k = this.props) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.createUrl) || undefined }));
        }
        else {
            this.props.actions.toggleShareScreen();
        }
    };
    FullscreenMobileBar.prototype.getTopMobileBar = function () {
        var _this = this;
        var mobileTopClassNames = classNames('fullscreen-mobile-bar', 'fullscreen-mobile-top', 'pro-fullscreen-store', 'fixed-items', {
            share: this.state.showShare,
        });
        return (React.createElement("div", { className: mobileTopClassNames },
            React.createElement("div", null,
                React.createElement("button", { className: "fullscreen-close progallery-svg-font-icons-back", key: 'fullscreen-close', onClick: function () {
                        var eventData = {
                            itemIdx: _this.props.current.idx,
                        };
                        _this.props.actions.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
                    } }),
                this.getShareContainer())));
    };
    FullscreenMobileBar.prototype.render = function () {
        var mobileBars = [];
        if (utils.isSmallScreen()) {
            mobileBars[0] = this.getTopMobileBar();
            mobileBars[1] = false;
        }
        var res = this.props.isFirst
            ? mobileBars[0] || false
            : mobileBars[1] || false;
        return res;
    };
    return FullscreenMobileBar;
}(React.Component));
export default FullscreenMobileBar;
//# sourceMappingURL=FullscreenMobileBar.js.map